package com.patronat.top.features.usermanagement.data.network

import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.core.domain.models.profiles.UserFilter
import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.safeApiCall
import com.patronat.top.dto.*
import com.patronat.top.features.usermanagement.data.mappers.toCreateUserRequest
import com.patronat.top.features.usermanagement.data.mappers.toRequest
import com.patronat.top.features.usermanagement.data.mappers.toUpdateUserRequest
import io.ktor.client.HttpClient
import io.ktor.client.request.*

class UserRemoteDataStore(
    private val httpClient: HttpClient,
) {
     suspend fun getCurrentUser(): NetworkResult<ProfileSuccessResponse> {
        return safeApiCall<ProfileSuccessResponse> {
            httpClient.get("users/me")
        }
    }

    suspend fun createUser(user: User): NetworkResult<ProfileSuccessResponse>{
        return safeApiCall {
            httpClient.post ("users/create"){setBody(user.toCreateUserRequest())}
        }
    }

    suspend fun getFilteredUsers(userFilter: UserFilter) : NetworkResult<ProfileListResponse> {
        return  safeApiCall {
            httpClient.post ("users/filter"){setBody(userFilter.toRequest())}
        }
    }

    suspend fun updateUserStatus(userId: String, newStatus: UserStatus): NetworkResult<Unit> {
        return safeApiCall {
            httpClient.patch("users/$userId/status") {
                setBody(UpdateUserStatusRequest(newStatus))
            }
        }
    }

    suspend fun getUserById(userId: String): NetworkResult<ProfileSuccessResponse> {
        return safeApiCall {
            httpClient.get("users/$userId")
        }
    }

    suspend fun updateUser(user: User): NetworkResult<Unit> {
        return safeApiCall {
            httpClient.put("users/${user.id}") {
                setBody(user.toUpdateUserRequest())
            }
        }
    }
}